'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_localization_AppLocale() {
}
export { $c_Lapp_localization_AppLocale as $c_Lapp_localization_AppLocale };
$c_Lapp_localization_AppLocale.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_localization_AppLocale.prototype.constructor = $c_Lapp_localization_AppLocale;
/** @constructor */
function $h_Lapp_localization_AppLocale() {
}
export { $h_Lapp_localization_AppLocale as $h_Lapp_localization_AppLocale };
$h_Lapp_localization_AppLocale.prototype = $c_Lapp_localization_AppLocale.prototype;
$c_Lapp_localization_AppLocale.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.localization.-App-Locale.js.map
